module.exports = __webpack_public_path__ + "static/media/uv2.5450db43.jpg";